<template>
    <div class="absolute top-0 left-0 w-full h-full rounded-lg flex flex-col gap-y-4 overflow-hidden">
        <div class="relative w-full h-full flex flex-col border rounded-lg bg-transparent sm:p-2 p-5 gap-y-5">
            <div class="absolute top-0 left-0 w-full h-full flex flex-col gap-4 p-4">
                <h2 class="text-xl mb-4 text-eblack-950">{{ $t("admin.auto.tags") }}</h2>

                <div class="w-full flex  justify-between gap-y-5">
                    <button 
                    type="button"
                    class="bg-egreen-400 w-auto text-white py-1.5 px-4 rounded-lg text-md inline-flex justify-center items-center gap-2"
                    @click="addCategory()">
                        <IconCirclePlus stroke={2} />
                        <span>{{ $t("admin.auto.agregar") }}</span>
                    </button>
                    <input 
                    type="text" 
                    name="search"
                    v-model="search" 
                    class="rounded-lg border-eblack-300 text-md sm:w-full md:w-80 focus:ring-blue-500 px-4 py-1.5"
                    @keyup="searchInput()"
                    :placeholder="$t('admin.auto.tag')">
                </div>
                <div 
                class="w-full max-h-full grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 overflow-y-auto gap-4 pt-6"
                v-if="tags_list.length > 0">
                    <div class="w-full flex justify-center" v-for="item in tags_list" v-bind:key="item.id">
                        <CardDropdown 
                        :tag="item" 
                        :setTag="setTag"
                        :initData="initData"
                        :deleteAdding="deleteAdding"></CardDropdown>
                    </div>
                </div>
                <div v-else class="flex flex-col items-center justify-center py-16 bg-ewhite-100 rounded-xl">
                    <div class="flex h-20 w-20 items-center justify-center rounded-full bg-eblack-100 mb-4">
                        <IconTag class="h-10 w-10 text-eblack-400" />
                    </div>
                    <p class="text-sm text-muted-foreground">{{ $t("admin.auto.no_se_encontraron_tags") }}</p>
                </div>
            </div>
        </div>
      
    </div>
</template>

<script>
    import { initFlowbite } from 'flowbite';
    import CardDropdown from './components/CardDropdown.vue';
    import tagsRequests from "@/services/admin/tags-service";
    import { IconCirclePlus, IconTag } from '@tabler/icons-vue';

    export default {
        name:"TagsIndex",
        data(){
            return {
                tag:{
                    id:0,
                    name:""
                },
                search:"",
                tags:[],
                tags_list:[]
            }
        },
        components:{
            CardDropdown,
            IconCirclePlus,
            IconTag
        },
        methods:{
            setTag(tag){
                this.tag = tag
            },
            setShowModal(value){
                this.showModal = value
            },
            initData(){
                tagsRequests.getAllTags().then(
                    res => {
                        if(res.status == 200){
                            let {data} = res
                            this.tags = data;
                            this.tags_list = data;
                        }
                    },
                    error => {
                        console.log(error)
                    }
                )
            },
            deleteAdding(){
                this.tags_list.splice(0,1)
            },
            searchInput(){
                if(this.search){
                    this.tags_list = this.tags.filter(item => item.name.toLowerCase().includes(this.search.toLowerCase()))
                }else{
                    this.tags_list = this.tags
                }
            },
            addCategory(){
                this.tags_list.unshift({
                    id:0,
                    name:""
                })
            },
        },
        mounted(){
            initFlowbite()
            this.initData()
        }
    }
</script>

<style lang="scss" scoped>

</style>